(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsInformationNotificationSubmenu', rmsInformationNotificationSubmenu);

    function rmsInformationNotificationSubmenu() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsInformationNotificationSubmenuCtrl,
            controllerAs: 'in_submenu_ctrl',
            bindToController: true,
            templateUrl: 'common/app/components/information-notification-submenu'
        };
    }

    function rmsInformationNotificationSubmenuCtrl(GenericModel, lodash, $scope, $rootScope, DialogManager) {

        var in_submenu_ctrl = this;
        var endpoint = '';
        var method = '';
        var data = [];

        this.$onInit = function() {
            in_submenu_ctrl.action = action;
            in_submenu_ctrl.mark_all_as_read = markAllAsRead;

            refresh();

            var event_name = lodash.get(in_submenu_ctrl.options, 'refresh_event', 'notification_badge_refresh');
            $scope.listener_instance = $rootScope.$on(event_name, function () {
                refresh();
            });

            $scope.$on('$destroy', function () {
                $scope.listener_instance();
            });
        }


        function refresh() {
            endpoint = lodash.get(in_submenu_ctrl.options, 'datasource.url', '');
            method = lodash.get(in_submenu_ctrl.options, 'datasource.method', 'get');
            const model = GenericModel(endpoint);

            model[method]().$promise.then(function (res) {
                in_submenu_ctrl.unread_count = (!!res.unread_count) ? res.unread_count : null;
                in_submenu_ctrl.rows = (!!res.rows) ? res.rows : null;
                in_submenu_ctrl.total = (!!res.total) ? res.total : res.count;
                in_submenu_ctrl.unread_count = (!!res.unread_count) ? res.unread_count : 0;
            });
        }

        // action();
        // ng-click="in_submenu_ctrl.action(row)"

        function action(item) {
            if (item.read_status.key == 'urd') {
                endpoint = lodash.get(in_submenu_ctrl.options, 'datasource_update.url', '');
                method = lodash.get(in_submenu_ctrl.options, 'datasource_update.method', 'put');
                const model = GenericModel(endpoint);

                data = {
                    selected: [{id: item.id}]
                };

                model[method]({}, data).$promise.then(function (res) {
                    refresh();
                });
            }

            switch (item.title_click_event) {
                case 1:
                    window.open(item.link, "_blank");
                    break;
                case 2:
                    DialogManager.init($scope.id, {
                        dialog_id: $scope.id,
                        dialog_options: {
                            modalSize: 'small',
                            modalClass: null,
                            hideModalHeader: true,
                            templates: item,
                        },
                        controller: "DialogAsyncCtrl",
                        controllerAs: "vm",
                        template: '<div class="modal annoucement display-block"><div class="modal-dialog <%vm.options.modalSize%> <%vm.options.modalClass%>  ">' +
                            '<div class="modal-content" style="padding: 0px;">' +
                            '<div class="modal-header" style="padding: 1rem;">' +
                            '<h4 class="modal-title"><div ng-bind="vm.options.templates.title" style="color:white;padding-right:30px;"></div></h4>' +
                            '<button class="close modal-close-btn" ng-click="vm.dismiss()"><i class="fa fa-times" style="color:white;padding: 10px;"></i></button>' +
                            '</div>' +
                            '<div class="modal-body">' +
                            '<div ng-bind-html="vm.options.templates.content"></div>' +
                            '</div>' +
                            '</div>' +
                            '</div></div>',
                    });
                    break;
                default:
                    break;
            }
        }

        function markAllAsRead() {
            endpoint = lodash.get(in_submenu_ctrl.options, 'datasource_update.url', '');
            method = lodash.get(in_submenu_ctrl.options, 'datasource_update.method', 'put');
            const model = GenericModel(endpoint);
            data = {
                isMassSelectedItems: true,
                selectAllFlag: true,
            };

            model[method]({}, data).$promise.then(function (res) {
                refresh();
            });
        }

    }
})();
